import { Observable } from 'rxjs';
import { HttpClient } from './http-client';
import { MlResourcesResponse } from '../pages/reports/vaad-liz-reports_v2/interfaces/ml-resources-response';
import { WorkOverviewItem } from '../pages/reports/vaad-liz-reports_v2/interfaces/work-overview-item';
import { SeedResourceItem } from '../pages/reports/vaad-liz-reports_v2/interfaces/seed-resource-item';
import { AalResourceItem } from '../pages/reports/vaad-liz-reports_v2/interfaces/aal-resource-item';
import { LimeResourceItem } from '../pages/reports/vaad-liz-reports_v2/interfaces/lime-resource-item';
import { EquipmentItem } from '../pages/reports/vaad-liz-reports_v2/interfaces/equipment-item';
import { LadFieldItem } from '../pages/reports/vaad-liz-reports_v2/interfaces/lad-field-item';
import { ReportListItem } from '../pages/reports/vaad-liz-reports_v2/interfaces/report-list-item';
import { EquipmentSubtypesResponse } from '../pages/reports/vaad-liz-reports_v2/interfaces/equipment-subtypes-response';

export class VaadLizReportV2Service extends HttpClient {
  index(farmId: string) {
    return this.get<ReportListItem[]>(
      `/api/farms/${farmId}/vaad-liz-reports/get-list-of-reports-data`
    );
  }

  // todo: remove after testing
  // getCurrentDate(farmId: string): Observable<any> {
  //   // return this.get<any>(
  //   //   `/api/farms/${farmId}/vaad-liz-reports/get-current-date`
  //   // );
  //
  //   if (!localStorage.getItem('current_date')) {
  //     localStorage.setItem('current_date', '07.11.2024')
  //   }
  //   return of(localStorage.getItem('current_date'));
  // }

  add(farmId: string) {
    return this.post<ReportListItem>(
      `/api/farms/${farmId}/vaad-liz-reports/create-liz-report`
    );
  }

  remove(farmId: string, id: string) {
    return this.delete<null>(
      `/api/farms/${farmId}/vaad-liz-reports/delete-report/${id}`
    );
  }

  removeLiz(farmId: string, id: string) {
    return this.delete<null>(
      `/api/farms/${farmId}/vaad-liz-reports/delete-report-from-liz/${id}`
    );
  }

  send(farmId: string, season_id: string, id: string): Observable<any> {
    return this.post<any>(`/api/farms/${farmId}/vaad-liz-reports/send-to-liz`, {
      report_id: id,
    });
  }

  getValidationInfoForField(
    farmId: string,
    id: string,
    fieldId: string
  ): Observable<any> {
    return this.get<any>(
      `/api/farms/${farmId}/vaad-liz-reports/validate-to-liz/${id}/validation-result/${fieldId}`
    );
  }

  validateLizStatus(farmId: string, id: string): Observable<any> {
    return this.get<any>(
      `/api/farms/${farmId}/vaad-liz-reports/validate-to-liz/${id}/status`
    );

    // if (!localStorage.getItem('liz_validation_status')) {
    //   localStorage.setItem('liz_validation_status', 'in_progress')
    // }
    // return of({liz_validation_status: localStorage.getItem('liz_validation_status')});
  }

  submitLiz(farmId: string, id: string): Observable<any> {
    return this.get<any>(
      `/api/farms/${farmId}/vaad-liz-reports/submit-to-liz/${id}`
    );
  }

  validateLiz(farmId: string, id: string): Observable<any> {
    return this.get<any>(
      `/api/farms/${farmId}/vaad-liz-reports/validate-to-liz/${id}`
    );
  }

  getLadFields(farmId: string, id: string, year: string) {
    return this.get<LadFieldItem[]>(
      `/api/farms/${farmId}/vaad-liz-reports/get-lad-fields/${id}/${year}`
    );
  }

  editReportsData(farmId: string, id: string, year: string) {
    return this.get<LadFieldItem[]>(
      `/api/farms/${farmId}/vaad-liz-reports/edit-reports-data/${id}/${year}`
    );
  }

  getWorkOverview(farmId: string, id: string) {
    return this.get<WorkOverviewItem[]>(
      `/api/farms/${farmId}/vaad-liz-reports/get-overview-of-work-list/${id}`
    );
  }

  removeWork(farmId: string, id: string, workId: string) {
    return this.delete<WorkOverviewItem[]>(
      `/api/farms/${farmId}/vaad-liz-reports/delete-overview-of-work/${id}/${workId}`
    );
  }

  getSeedResources(farmId: string, id: string) {
    return this.get<SeedResourceItem[]>(
      `/api/farms/${farmId}/vaad-liz-reports/get-seed-resource-list/${id}`
    );
  }

  getAalResoures(farmId: string, id: string) {
    return this.get<AalResourceItem[]>(
      `/api/farms/${farmId}/vaad-liz-reports/get-plant-protection-resource-list/${id}`
    );
  }

  getMlResources(farmId: string, id: string) {
    return this.get<MlResourcesResponse>(
      `/api/farms/${farmId}/vaad-liz-reports/get-fertilization-resource-list/${id}`
    );
  }

  getLimeResources(farmId: string, id: string) {
    return this.get<LimeResourceItem[]>(
      `/api/farms/${farmId}/vaad-liz-reports/get-liming-resource-list/${id}`
    );
  }

  getEquipment(farmId: string, id: string) {
    return this.get<EquipmentItem[]>(
      `/api/farms/${farmId}/vaad-liz-reports/get-equipment-resource-list/${id}`
    );
  }

  getEquipmentSubtypes(farmId: string) {
    return this.get<EquipmentSubtypesResponse>(
      `/api/farms/${farmId}/vaad-liz-reports/get-equipment-subtypes`
    );
  }

  removeEquipment(farmId: string, id: string, techniqueId: string) {
    return this.delete<EquipmentItem[]>(
      `/api/farms/${farmId}/vaad-liz-reports/delete-equipment-resource/${id}/${techniqueId}`
    );
  }

  saveWorkOverview(
    farmId: string,
    reportId: string,
    data: { works: WorkOverviewItem[] }
  ) {
    return this.patch<WorkOverviewItem[]>(
      `/api/farms/${farmId}/vaad-liz-reports/update-overview-of-work-list/${reportId}`,
      data
    );
  }

  saveSeedResources(
    farmId: string,
    reportId: string,
    data: SeedResourceItem[]
  ) {
    return this.patch<SeedResourceItem[]>(
      `/api/farms/${farmId}/vaad-liz-reports/update-seed-resource-list/${reportId}`,
      data
    );
  }

  saveAalResources(farmId: string, reportId: string, data: AalResourceItem[]) {
    return this.patch<AalResourceItem[]>(
      `/api/farms/${farmId}/vaad-liz-reports/update-plant-protection-resource-list/${reportId}`,
      data
    );
  }

  saveMlResources(farmId: string, reportId: string, data: MlResourcesResponse) {
    return this.patch<MlResourcesResponse>(
      `/api/farms/${farmId}/vaad-liz-reports/update-fertilization-resource-list/${reportId}`,
      data
    );
  }

  saveLimeResources(
    farmId: string,
    reportId: string,
    data: LimeResourceItem[]
  ) {
    return this.patch<LimeResourceItem[]>(
      `/api/farms/${farmId}/vaad-liz-reports/update-liming-resource-list/${reportId}`,
      data
    );
  }

  saveEquipment(farmId: string, reportId: string, data: EquipmentItem[]) {
    return this.patch<EquipmentItem[]>(
      `/api/farms/${farmId}/vaad-liz-reports/update-equipment-resource-list/${reportId}`,
      data
    );
  }

  exportListXls(farmId: string, reportId: string) {
    return this.export(
      `/api/farms/${farmId}/vaad-liz-reports/export-liz-validation/${reportId}`
    );
  }
}
